// extracted by mini-css-extract-plugin
export default {"sumItem":"homeStyles_sumItem__TS7+3"};